import { render } from "./RadioGroup.vue?vue&type=template&id=0a298963&scoped=true&ts=true"
import script from "./RadioGroup.vue?vue&type=script&lang=ts"
export * from "./RadioGroup.vue?vue&type=script&lang=ts"

import "./RadioGroup.vue?vue&type=style&index=0&id=0a298963&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a298963"]])

export default __exports__